import React from 'react';
import styles from './LoginField.module.scss';
import {
  FieldContainer,
  FieldContainerProps,
} from '../../components/field/FieldContainer';

export function LoginField(props: FieldContainerProps) {
  return (
    <div className={styles.container}>
      <FieldContainer {...props} />
    </div>
  );
}
